import { NgModule } from '@angular/core';

import { UgcLinksHighlightPipe } from './UgcLinksHighlight.pipe';

@NgModule({
  declarations: [UgcLinksHighlightPipe],
  exports: [UgcLinksHighlightPipe],
})
export class UgcLinksHighlightPipeModule {}
